// A template string turns a missing image into the text "null" or "undefined",
// and the browser then requests it relative to the page: /coaches/null,
// /track/null. Build image URLs through these so a missing value means no image.

function isUsableImageUrl(value) {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined';
}

// For <img src> / next/image: the value, or the fallback (undefined by default,
// which React leaves off the element, so nothing is requested).
function imageSrc(value, fallback) {
  return isUsableImageUrl(value) ? value : fallback;
}

// For CSS backgrounds: `url("…")`, or `none` when there is no usable image.
function cssImageUrl(value, fallback) {
  const src = imageSrc(value, fallback);
  return src ? `url("${src}")` : 'none';
}

// For public SSR props: only the URL fields (images, video) that hold a usable
// URL. A `null` left in __NEXT_DATA__ is read by some crawlers as a relative
// link and fetched as /track/null, and they follow any URL-looking field, not
// only images, so a missing URL is left out rather than sent as null.
function usableUrlFields(source, keys) {
  const fields = {};
  keys.forEach((key) => {
    if (isUsableImageUrl(source?.[key])) fields[key] = source[key];
  });
  return fields;
}

export { cssImageUrl, imageSrc, isUsableImageUrl, usableUrlFields };
